export * from './shadcn.js'
export * from './lib/rate.js'
export * from './lib/country.js'
import { installShadcn } from './shadcn.js'

export function install(app) {
  installShadcn(app)
}

export default { install }
